import styled from "@emotion/styled";
import { Typography } from "@mui/material";

export const StyledPageTitle = styled(Typography)`
font-family: GenYOGothic2TW;
    font-weight: bold;
    font-size: 42px;
    color: #515151;
    margin-bottom: 0.8em;
`
